import { goToStep, loadAuthState } from "../auth";
import { isCaptchaError, mountCaptcha } from "../captcha";
import { nextStep } from "../routes";
import { supabase } from "../supabase";
import { t } from "../strings/en";
import { applyStrings, byId, setBusy, setMessage, showPanel } from "../ui";

applyStrings();

const form = byId<HTMLFormElement>("form");
const email = byId<HTMLInputElement>("email");
const password = byId<HTMLInputElement>("password");
const submit = byId<HTMLButtonElement>("submit");
const message = byId("message");
const captcha = mountCaptcha(byId("captcha"));
const challengeForm = byId<HTMLFormElement>("challengeForm");
const code = byId<HTMLInputElement>("code");
const challengeSubmit = byId<HTMLButtonElement>("challengeSubmit");
const challengeMessage = byId("challengeMessage");
const cancel = byId<HTMLButtonElement>("cancel");

// Depois do login, ou ao abrir a página já com sessão aal1: decide o passo.
// Esta página é dona do passo mfa-challenge.
async function route(): Promise<void> {
  const step = nextStep(await loadAuthState());
  if (step === "mfa-challenge") {
    showPanel("panel-challenge");
    code.focus();
  } else if (step === "login") {
    showPanel("panel-form");
  } else {
    goToStep(step);
  }
}

form.addEventListener("submit", async (e) => {
  e.preventDefault();
  setMessage(message, null);
  const blocked = captcha.blocker();
  if (blocked) return setMessage(message, blocked);
  setBusy(submit, true);
  try {
    const { error } = await supabase.auth.signInWithPassword({
      email: email.value.trim(),
      password: password.value,
      options: { captchaToken: captcha.token() },
    });
    if (error) {
      if (isCaptchaError(error)) setMessage(message, t("captchaFailed"));
      else if (error.code === "email_not_confirmed") setMessage(message, t("loginEmailNotConfirmed"));
      else if (error.code === "invalid_credentials") setMessage(message, t("loginInvalid"));
      else if (error.status === 429) setMessage(message, t("authTooMany"));
      else setMessage(message, t("genericError"));
      return;
    }
    password.value = "";
    await route();
  } catch {
    setMessage(message, t("networkError"));
  } finally {
    // O token é de uso único: o próximo envio precisa de outro.
    captcha.reset();
    setBusy(submit, false);
  }
});

challengeForm.addEventListener("submit", async (e) => {
  e.preventDefault();
  setMessage(challengeMessage, null);
  setBusy(challengeSubmit, true);
  try {
    const { data: factors, error: listError } = await supabase.auth.mfa.listFactors();
    const factor = factors?.totp[0];
    if (listError || !factor) return setMessage(challengeMessage, t("genericError"));
    const { error } = await supabase.auth.mfa.challengeAndVerify({
      factorId: factor.id,
      code: code.value.trim(),
    });
    if (error) {
      const invalid = error.status === 400 || error.status === 422;
      setMessage(challengeMessage, invalid ? t("challengeInvalid") : t(error.status === 429 ? "authTooMany" : "genericError"));
      code.select();
      return;
    }
    goToStep(nextStep(await loadAuthState()));
  } catch {
    setMessage(challengeMessage, t("networkError"));
  } finally {
    setBusy(challengeSubmit, false);
  }
});

cancel.addEventListener("click", async () => {
  await supabase.auth.signOut();
  code.value = "";
  showPanel("panel-form");
});

void route().catch(() => {
  showPanel("panel-form");
  setMessage(message, t("networkError"));
});
